<template>

    <div v-if="loaded">
        <div class="nav-tabs-custom submenu">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="routeTo(child)">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view
            @companyDataChanged="update"
        ></router-view>
    </div>
    <div v-else>
        <loader></loader>
    </div>

</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import Loader from "../../../components/Common/Loader";
import MenuItem from "../../../Libraries/MenuItem";

export default {

    components: {
        Loader,
    },

    computed: {
        ...mapGetters([
            'getCompany',
        ]),

        getMenu() {
            let menu = [
                new MenuItem(this.getCompany.name, {name:'crm.companies.show', params:{uuid:this.getCompany.uuid}}),
            ];

            return menu;
        },
    },

    data() {
        return {
            loaded:false,
        }
    },

    methods: {
        ...mapActions([
            'setCompany',
            'setHasSubMenu',
        ]),

        getCompanyData(uuid) {
            axios.get(this.route('api.v1.crm.companies.show', {uuid:uuid}))
                .then(resp => {
                    this.setCompany(resp.data.data);
                    this.loaded = true;
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van de bedrijven'));
        },

        isActiveChildRoute(child) {
            let routeName;
            if (typeof child.route === 'string') {
                routeName = child.route;
            } else {
                routeName = child.route.name;
            }

            if (routeName == 'crm.companies.show' && this.$route.name == 'crm.companies.edit') {
                return true;
            }

            return routeName === this.$route.name;
        },

        routeTo(child) {
            if (typeof child.route === 'string') {
                return {name:child.route};
            }
            return {
                name:child.route.name,
                params:child.route.params,
            };
        },

        update() {
            this.getCompanyData(this.$route.params.uuid);
        },
    },

    mounted(){
        this.update();
        this.setHasSubMenu(true);
    },

    destroyed() {
        this.setHasSubMenu(false);
    },

    name:'CrmCompaniesLayout',

}

</script>
